import { default as aboutpwON433gxNMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsdHt90fqbA3Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_934kYeZHeT9YMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample9IeAzMzs0DMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsC9755yrYpnMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_937YPUxi1dMkMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewRwCf710WaqMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexMFIpRCjjtsMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ePFrMDIBMhMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexspFyXPgcusMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93Oq2eK0yuhGMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexPdzGnCZ7MsMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsWHfC0I67cZMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsffALhMT1KfMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsUUArSATZoMMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_931IW9ZZtgPYMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as index6o24YnCnxWMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmxu4QksgpbuMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmeB8VT8ZhXVMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarNQmTpyg4QmMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/calendar.vue?macro=true";
import { default as chat3uRb8bHYPlMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutfe86LPG0CJMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feednu3wdM2haTMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersTzXFUMYasBMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93WBFdJfKZnlMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editLKajNQnScwMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93CaGbDH5fZcMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityfSN9a1NA0NMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_938huXFplFPWMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93AmnAMWykslMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardN8OLPFp0xcMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexhrTRb1Cbj5Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutIjYBLBc31aMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productTavZEaIGXUMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsVA8IShZBpoMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93ChDIfg7THRMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as index28EBeVUY3nMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93H0fbJGJxiMMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_930Y5khBSDttMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexhEpWmIpIQEMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93bB60TnCPCLMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinQINl6ARGCiMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/join.vue?macro=true";
import { default as logincd6IGz50rhMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/login.vue?macro=true";
import { default as logoutCpb9Tyz8COMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_930ZdL6crhlwMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93fsfFulGbcCMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93eTgAXb3mONMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesYX8Yfp6vNMMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosVWjyAWvhYsMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinsdaBGN5r8aMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93Ipsgu0dEZFMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexdLv4wLH4PDMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexwfuGim7QIhMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutAY3ZC3MiGMMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45content5MnsvDXp8GMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsHYUksDkRKQMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93FlScGc2LwVMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplejD2G0c6JlUMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsuJ6rV8wGRAMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93tXS1q9lbBpMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewpopkvnycTkMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexjauu9tdgvnMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93fZyRhuwbIrMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexAyaN3sAbxnMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_9307i9q0LmyIMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexIqxM8OY9AHMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsNS3JgfqQDIMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingstN6Fmx9SQ0Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewssfRvbL3B8lMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93ZC0KFyJutXMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexCFQPJmull4Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexYQtSWIwH1AMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchases15EtCthTkRMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsITqhRUadZ5Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93vL1moyuhK1Meta } from "/tmp/build_bdce9e5f/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93VW8NLOnhELMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetFhPW3F48igMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/reset.vue?macro=true";
import { default as shopQn55y98ebBMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/shop.vue?macro=true";
import { default as signupb4519wCVMpMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/signup.vue?macro=true";
import { default as liveY9e9SNIgFmMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsyaY5mUMgWRMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93G26CB2T3fBMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactqgpqNYq82aMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullgQrkTJDZOSMeta } from "/tmp/build_bdce9e5f/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_931IW9ZZtgPYMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_931IW9ZZtgPYMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_931IW9ZZtgPYMeta || {},
    alias: _91product_id_931IW9ZZtgPYMeta?.alias || [],
    redirect: _91product_id_931IW9ZZtgPYMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutpwON433gxNMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutpwON433gxNMeta?.path ?? "about",
    meta: aboutpwON433gxNMeta || {},
    alias: aboutpwON433gxNMeta?.alias || [],
    redirect: aboutpwON433gxNMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsdHt90fqbA3Meta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsdHt90fqbA3Meta?.path ?? "events",
    meta: eventsdHt90fqbA3Meta || {},
    alias: eventsdHt90fqbA3Meta?.alias || [],
    redirect: eventsdHt90fqbA3Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934kYeZHeT9YMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_934kYeZHeT9YMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_934kYeZHeT9YMeta || {},
    alias: _91media_id_934kYeZHeT9YMeta?.alias || [],
    redirect: _91media_id_934kYeZHeT9YMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample9IeAzMzs0DMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sample9IeAzMzs0DMeta?.path ?? "free-sample",
    meta: free_45sample9IeAzMzs0DMeta || {},
    alias: free_45sample9IeAzMzs0DMeta?.alias || [],
    redirect: free_45sample9IeAzMzs0DMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsC9755yrYpnMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsC9755yrYpnMeta?.path ?? "included-products",
    meta: included_45productsC9755yrYpnMeta || {},
    alias: included_45productsC9755yrYpnMeta?.alias || [],
    redirect: included_45productsC9755yrYpnMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_937YPUxi1dMkMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_937YPUxi1dMkMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_937YPUxi1dMkMeta || {},
    alias: _91media_id_937YPUxi1dMkMeta?.alias || [],
    redirect: _91media_id_937YPUxi1dMkMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewRwCf710WaqMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewRwCf710WaqMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewRwCf710WaqMeta || {},
    alias: viewRwCf710WaqMeta?.alias || [],
    redirect: viewRwCf710WaqMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexMFIpRCjjtsMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexMFIpRCjjtsMeta?.path ?? "lessons",
    meta: indexMFIpRCjjtsMeta || {},
    alias: indexMFIpRCjjtsMeta?.alias || [],
    redirect: indexMFIpRCjjtsMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ePFrMDIBMhMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93ePFrMDIBMhMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93ePFrMDIBMhMeta || {},
    alias: _91media_id_93ePFrMDIBMhMeta?.alias || [],
    redirect: _91media_id_93ePFrMDIBMhMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexspFyXPgcusMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexspFyXPgcusMeta?.path ?? "playlists/:playlist_id()",
    meta: indexspFyXPgcusMeta || {},
    alias: indexspFyXPgcusMeta?.alias || [],
    redirect: indexspFyXPgcusMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Oq2eK0yuhGMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93Oq2eK0yuhGMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93Oq2eK0yuhGMeta || {},
    alias: _91media_id_93Oq2eK0yuhGMeta?.alias || [],
    redirect: _91media_id_93Oq2eK0yuhGMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexPdzGnCZ7MsMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexPdzGnCZ7MsMeta?.path ?? "playlists",
    meta: indexPdzGnCZ7MsMeta || {},
    alias: indexPdzGnCZ7MsMeta?.alias || [],
    redirect: indexPdzGnCZ7MsMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsWHfC0I67cZMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsWHfC0I67cZMeta?.path ?? "private-sessions",
    meta: private_45sessionsWHfC0I67cZMeta || {},
    alias: private_45sessionsWHfC0I67cZMeta?.alias || [],
    redirect: private_45sessionsWHfC0I67cZMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsffALhMT1KfMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsffALhMT1KfMeta?.path ?? "recordings",
    meta: recordingsffALhMT1KfMeta || {},
    alias: recordingsffALhMT1KfMeta?.alias || [],
    redirect: recordingsffALhMT1KfMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsUUArSATZoMMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsUUArSATZoMMeta?.path ?? "reviews",
    meta: reviewsUUArSATZoMMeta || {},
    alias: reviewsUUArSATZoMMeta?.alias || [],
    redirect: reviewsUUArSATZoMMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index6o24YnCnxWMeta?.name ?? "buy-product-product_id",
    path: index6o24YnCnxWMeta?.path ?? "/buy/product/:product_id()",
    meta: index6o24YnCnxWMeta || {},
    alias: index6o24YnCnxWMeta?.alias || [],
    redirect: index6o24YnCnxWMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmxu4QksgpbuMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmxu4QksgpbuMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmxu4QksgpbuMeta || {},
    alias: confirmxu4QksgpbuMeta?.alias || [],
    redirect: confirmxu4QksgpbuMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmeB8VT8ZhXVMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmeB8VT8ZhXVMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmeB8VT8ZhXVMeta || {},
    alias: confirmeB8VT8ZhXVMeta?.alias || [],
    redirect: confirmeB8VT8ZhXVMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarNQmTpyg4QmMeta?.name ?? "calendar",
    path: calendarNQmTpyg4QmMeta?.path ?? "/calendar",
    meta: calendarNQmTpyg4QmMeta || {},
    alias: calendarNQmTpyg4QmMeta?.alias || [],
    redirect: calendarNQmTpyg4QmMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chat3uRb8bHYPlMeta?.name ?? "chat",
    path: chat3uRb8bHYPlMeta?.path ?? "/chat",
    meta: chat3uRb8bHYPlMeta || {},
    alias: chat3uRb8bHYPlMeta?.alias || [],
    redirect: chat3uRb8bHYPlMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93WBFdJfKZnlMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93WBFdJfKZnlMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93WBFdJfKZnlMeta || {},
    alias: _91group_id_93WBFdJfKZnlMeta?.alias || [],
    redirect: _91group_id_93WBFdJfKZnlMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutfe86LPG0CJMeta?.name ?? "community-groups-group_id-about",
    path: aboutfe86LPG0CJMeta?.path ?? "about",
    meta: aboutfe86LPG0CJMeta || {},
    alias: aboutfe86LPG0CJMeta?.alias || [],
    redirect: aboutfe86LPG0CJMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feednu3wdM2haTMeta?.name ?? "community-groups-group_id-feed",
    path: feednu3wdM2haTMeta?.path ?? "feed",
    meta: feednu3wdM2haTMeta || {},
    alias: feednu3wdM2haTMeta?.alias || [],
    redirect: feednu3wdM2haTMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersTzXFUMYasBMeta?.name ?? "community-groups-group_id-members",
    path: membersTzXFUMYasBMeta?.path ?? "members",
    meta: membersTzXFUMYasBMeta || {},
    alias: membersTzXFUMYasBMeta?.alias || [],
    redirect: membersTzXFUMYasBMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editLKajNQnScwMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editLKajNQnScwMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editLKajNQnScwMeta || {},
    alias: community_45profile_45editLKajNQnScwMeta?.alias || [],
    redirect: community_45profile_45editLKajNQnScwMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93CaGbDH5fZcMeta?.name ?? "community-profile-id",
    path: _91id_93CaGbDH5fZcMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93CaGbDH5fZcMeta || {},
    alias: _91id_93CaGbDH5fZcMeta?.alias || [],
    redirect: _91id_93CaGbDH5fZcMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityfSN9a1NA0NMeta?.name ?? "community",
    path: communityfSN9a1NA0NMeta?.path ?? "/community",
    meta: communityfSN9a1NA0NMeta || {},
    alias: communityfSN9a1NA0NMeta?.alias || [],
    redirect: communityfSN9a1NA0NMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_938huXFplFPWMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_938huXFplFPWMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_938huXFplFPWMeta || {},
    alias: _91uuid_938huXFplFPWMeta?.alias || [],
    redirect: _91uuid_938huXFplFPWMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93AmnAMWykslMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93AmnAMWykslMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93AmnAMWykslMeta || {},
    alias: _91unique_id_93AmnAMWykslMeta?.alias || [],
    redirect: _91unique_id_93AmnAMWykslMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardN8OLPFp0xcMeta?.name ?? "dashboard",
    path: dashboardN8OLPFp0xcMeta?.path ?? "/dashboard",
    meta: dashboardN8OLPFp0xcMeta || {},
    alias: dashboardN8OLPFp0xcMeta?.alias || [],
    redirect: dashboardN8OLPFp0xcMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexhrTRb1Cbj5Meta?.name ?? "event-details-event_id",
    path: indexhrTRb1Cbj5Meta?.path ?? "/event/details/:event_id()",
    meta: indexhrTRb1Cbj5Meta || {},
    alias: indexhrTRb1Cbj5Meta?.alias || [],
    redirect: indexhrTRb1Cbj5Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutIjYBLBc31aMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutIjYBLBc31aMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutIjYBLBc31aMeta || {},
    alias: checkoutIjYBLBc31aMeta?.alias || [],
    redirect: checkoutIjYBLBc31aMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productTavZEaIGXUMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productTavZEaIGXUMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productTavZEaIGXUMeta || {},
    alias: select_45productTavZEaIGXUMeta?.alias || [],
    redirect: select_45productTavZEaIGXUMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsVA8IShZBpoMeta?.name ?? "events",
    path: eventsVA8IShZBpoMeta?.path ?? "/events",
    meta: eventsVA8IShZBpoMeta || {},
    alias: eventsVA8IShZBpoMeta?.alias || [],
    redirect: eventsVA8IShZBpoMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93ChDIfg7THRMeta?.name ?? "gifts-uuid",
    path: _91uuid_93ChDIfg7THRMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93ChDIfg7THRMeta || {},
    alias: _91uuid_93ChDIfg7THRMeta?.alias || [],
    redirect: _91uuid_93ChDIfg7THRMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: index28EBeVUY3nMeta?.name ?? "gifts",
    path: index28EBeVUY3nMeta?.path ?? "/gifts",
    meta: index28EBeVUY3nMeta || {},
    alias: index28EBeVUY3nMeta?.alias || [],
    redirect: index28EBeVUY3nMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93H0fbJGJxiMMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93H0fbJGJxiMMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93H0fbJGJxiMMeta || {},
    alias: _91invitation_id_93H0fbJGJxiMMeta?.alias || [],
    redirect: _91invitation_id_93H0fbJGJxiMMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_930Y5khBSDttMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_930Y5khBSDttMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_930Y5khBSDttMeta || {},
    alias: _91product_id_930Y5khBSDttMeta?.alias || [],
    redirect: _91product_id_930Y5khBSDttMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexhEpWmIpIQEMeta?.name ?? "index",
    path: indexhEpWmIpIQEMeta?.path ?? "/",
    meta: indexhEpWmIpIQEMeta || {},
    alias: indexhEpWmIpIQEMeta?.alias || [],
    redirect: indexhEpWmIpIQEMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93bB60TnCPCLMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93bB60TnCPCLMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93bB60TnCPCLMeta || {},
    alias: _91invitation_unique_id_93bB60TnCPCLMeta?.alias || [],
    redirect: _91invitation_unique_id_93bB60TnCPCLMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinQINl6ARGCiMeta?.name ?? "join",
    path: joinQINl6ARGCiMeta?.path ?? "/join",
    meta: joinQINl6ARGCiMeta || {},
    alias: joinQINl6ARGCiMeta?.alias || [],
    redirect: joinQINl6ARGCiMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: logincd6IGz50rhMeta?.name ?? "login",
    path: logincd6IGz50rhMeta?.path ?? "/login",
    meta: logincd6IGz50rhMeta || {},
    alias: logincd6IGz50rhMeta?.alias || [],
    redirect: logincd6IGz50rhMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutCpb9Tyz8COMeta?.name ?? "logout",
    path: logoutCpb9Tyz8COMeta?.path ?? "/logout",
    meta: logoutCpb9Tyz8COMeta || {},
    alias: logoutCpb9Tyz8COMeta?.alias || [],
    redirect: logoutCpb9Tyz8COMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_930ZdL6crhlwMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_930ZdL6crhlwMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_930ZdL6crhlwMeta || {},
    alias: _91meeting_type_slug_930ZdL6crhlwMeta?.alias || [],
    redirect: _91meeting_type_slug_930ZdL6crhlwMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93fsfFulGbcCMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93fsfFulGbcCMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93fsfFulGbcCMeta || {},
    alias: _91meeting_unique_id_93fsfFulGbcCMeta?.alias || [],
    redirect: _91meeting_unique_id_93fsfFulGbcCMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93eTgAXb3mONMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93eTgAXb3mONMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93eTgAXb3mONMeta || {},
    alias: _91meeting_unique_id_93eTgAXb3mONMeta?.alias || [],
    redirect: _91meeting_unique_id_93eTgAXb3mONMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesYX8Yfp6vNMMeta?.name ?? "my-favorites",
    path: my_45favoritesYX8Yfp6vNMMeta?.path ?? "/my-favorites",
    meta: my_45favoritesYX8Yfp6vNMMeta || {},
    alias: my_45favoritesYX8Yfp6vNMMeta?.alias || [],
    redirect: my_45favoritesYX8Yfp6vNMMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosVWjyAWvhYsMeta?.name ?? "my-studios",
    path: my_45studiosVWjyAWvhYsMeta?.path ?? "/my-studios",
    meta: my_45studiosVWjyAWvhYsMeta || {},
    alias: my_45studiosVWjyAWvhYsMeta?.alias || [],
    redirect: my_45studiosVWjyAWvhYsMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinsdaBGN5r8aMeta?.name ?? "optin",
    path: optinsdaBGN5r8aMeta?.path ?? "/optin",
    meta: optinsdaBGN5r8aMeta || {},
    alias: optinsdaBGN5r8aMeta?.alias || [],
    redirect: optinsdaBGN5r8aMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93Ipsgu0dEZFMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93Ipsgu0dEZFMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93Ipsgu0dEZFMeta || {},
    alias: _91episode_id_93Ipsgu0dEZFMeta?.alias || [],
    redirect: _91episode_id_93Ipsgu0dEZFMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexdLv4wLH4PDMeta?.name ?? "podcasts-podcast_id",
    path: indexdLv4wLH4PDMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexdLv4wLH4PDMeta || {},
    alias: indexdLv4wLH4PDMeta?.alias || [],
    redirect: indexdLv4wLH4PDMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexwfuGim7QIhMeta?.name ?? "podcasts",
    path: indexwfuGim7QIhMeta?.path ?? "/podcasts",
    meta: indexwfuGim7QIhMeta || {},
    alias: indexwfuGim7QIhMeta?.alias || [],
    redirect: indexwfuGim7QIhMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93ZC0KFyJutXMeta?.name ?? "product-product_id",
    path: _91product_id_93ZC0KFyJutXMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93ZC0KFyJutXMeta || {},
    alias: _91product_id_93ZC0KFyJutXMeta?.alias || [],
    redirect: _91product_id_93ZC0KFyJutXMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutAY3ZC3MiGMMeta?.name ?? "product-product_id-about",
    path: aboutAY3ZC3MiGMMeta?.path ?? "about",
    meta: aboutAY3ZC3MiGMMeta || {},
    alias: aboutAY3ZC3MiGMMeta?.alias || [],
    redirect: aboutAY3ZC3MiGMMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45content5MnsvDXp8GMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45content5MnsvDXp8GMeta?.path ?? "digital-download-content",
    meta: digital_45download_45content5MnsvDXp8GMeta || {},
    alias: digital_45download_45content5MnsvDXp8GMeta?.alias || [],
    redirect: digital_45download_45content5MnsvDXp8GMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsHYUksDkRKQMeta?.name ?? "product-product_id-events",
    path: eventsHYUksDkRKQMeta?.path ?? "events",
    meta: eventsHYUksDkRKQMeta || {},
    alias: eventsHYUksDkRKQMeta?.alias || [],
    redirect: eventsHYUksDkRKQMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93FlScGc2LwVMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93FlScGc2LwVMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93FlScGc2LwVMeta || {},
    alias: _91media_id_93FlScGc2LwVMeta?.alias || [],
    redirect: _91media_id_93FlScGc2LwVMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplejD2G0c6JlUMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplejD2G0c6JlUMeta?.path ?? "free-sample",
    meta: free_45samplejD2G0c6JlUMeta || {},
    alias: free_45samplejD2G0c6JlUMeta?.alias || [],
    redirect: free_45samplejD2G0c6JlUMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsuJ6rV8wGRAMeta?.name ?? "product-product_id-included-products",
    path: included_45productsuJ6rV8wGRAMeta?.path ?? "included-products",
    meta: included_45productsuJ6rV8wGRAMeta || {},
    alias: included_45productsuJ6rV8wGRAMeta?.alias || [],
    redirect: included_45productsuJ6rV8wGRAMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93tXS1q9lbBpMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93tXS1q9lbBpMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93tXS1q9lbBpMeta || {},
    alias: _91media_id_93tXS1q9lbBpMeta?.alias || [],
    redirect: _91media_id_93tXS1q9lbBpMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewpopkvnycTkMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewpopkvnycTkMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewpopkvnycTkMeta || {},
    alias: viewpopkvnycTkMeta?.alias || [],
    redirect: viewpopkvnycTkMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexjauu9tdgvnMeta?.name ?? "product-product_id-lessons",
    path: indexjauu9tdgvnMeta?.path ?? "lessons",
    meta: indexjauu9tdgvnMeta || {},
    alias: indexjauu9tdgvnMeta?.alias || [],
    redirect: indexjauu9tdgvnMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93fZyRhuwbIrMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93fZyRhuwbIrMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93fZyRhuwbIrMeta || {},
    alias: _91media_id_93fZyRhuwbIrMeta?.alias || [],
    redirect: _91media_id_93fZyRhuwbIrMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexAyaN3sAbxnMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexAyaN3sAbxnMeta?.path ?? "playlists/:playlist_id()",
    meta: indexAyaN3sAbxnMeta || {},
    alias: indexAyaN3sAbxnMeta?.alias || [],
    redirect: indexAyaN3sAbxnMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_9307i9q0LmyIMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_9307i9q0LmyIMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_9307i9q0LmyIMeta || {},
    alias: _91media_id_9307i9q0LmyIMeta?.alias || [],
    redirect: _91media_id_9307i9q0LmyIMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexIqxM8OY9AHMeta?.name ?? "product-product_id-playlists",
    path: indexIqxM8OY9AHMeta?.path ?? "playlists",
    meta: indexIqxM8OY9AHMeta || {},
    alias: indexIqxM8OY9AHMeta?.alias || [],
    redirect: indexIqxM8OY9AHMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsNS3JgfqQDIMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsNS3JgfqQDIMeta?.path ?? "private-sessions",
    meta: private_45sessionsNS3JgfqQDIMeta || {},
    alias: private_45sessionsNS3JgfqQDIMeta?.alias || [],
    redirect: private_45sessionsNS3JgfqQDIMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingstN6Fmx9SQ0Meta?.name ?? "product-product_id-recordings",
    path: recordingstN6Fmx9SQ0Meta?.path ?? "recordings",
    meta: recordingstN6Fmx9SQ0Meta || {},
    alias: recordingstN6Fmx9SQ0Meta?.alias || [],
    redirect: recordingstN6Fmx9SQ0Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewssfRvbL3B8lMeta?.name ?? "product-product_id-reviews",
    path: reviewssfRvbL3B8lMeta?.path ?? "reviews",
    meta: reviewssfRvbL3B8lMeta || {},
    alias: reviewssfRvbL3B8lMeta?.alias || [],
    redirect: reviewssfRvbL3B8lMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexCFQPJmull4Meta?.name ?? "product",
    path: indexCFQPJmull4Meta?.path ?? "/product",
    meta: indexCFQPJmull4Meta || {},
    alias: indexCFQPJmull4Meta?.alias || [],
    redirect: indexCFQPJmull4Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexYQtSWIwH1AMeta?.name ?? "profile",
    path: indexYQtSWIwH1AMeta?.path ?? "/profile",
    meta: indexYQtSWIwH1AMeta || {},
    alias: indexYQtSWIwH1AMeta?.alias || [],
    redirect: indexYQtSWIwH1AMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchases15EtCthTkRMeta?.name ?? "profile-purchases",
    path: purchases15EtCthTkRMeta?.path ?? "/profile/purchases",
    meta: purchases15EtCthTkRMeta || {},
    alias: purchases15EtCthTkRMeta?.alias || [],
    redirect: purchases15EtCthTkRMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsITqhRUadZ5Meta?.name ?? "profile-redemptions",
    path: redemptionsITqhRUadZ5Meta?.path ?? "/profile/redemptions",
    meta: redemptionsITqhRUadZ5Meta || {},
    alias: redemptionsITqhRUadZ5Meta?.alias || [],
    redirect: redemptionsITqhRUadZ5Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93vL1moyuhK1Meta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93vL1moyuhK1Meta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93vL1moyuhK1Meta || {},
    alias: _91quiz_id_93vL1moyuhK1Meta?.alias || [],
    redirect: _91quiz_id_93vL1moyuhK1Meta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93VW8NLOnhELMeta?.name ?? "reset-password-uid-token",
    path: _91token_93VW8NLOnhELMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93VW8NLOnhELMeta || {},
    alias: _91token_93VW8NLOnhELMeta?.alias || [],
    redirect: _91token_93VW8NLOnhELMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetFhPW3F48igMeta?.name ?? "reset",
    path: resetFhPW3F48igMeta?.path ?? "/reset",
    meta: resetFhPW3F48igMeta || {},
    alias: resetFhPW3F48igMeta?.alias || [],
    redirect: resetFhPW3F48igMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopQn55y98ebBMeta?.name ?? "shop",
    path: shopQn55y98ebBMeta?.path ?? "/shop",
    meta: shopQn55y98ebBMeta || {},
    alias: shopQn55y98ebBMeta?.alias || [],
    redirect: shopQn55y98ebBMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupb4519wCVMpMeta?.name ?? "signup",
    path: signupb4519wCVMpMeta?.path ?? "/signup",
    meta: signupb4519wCVMpMeta || {},
    alias: signupb4519wCVMpMeta?.alias || [],
    redirect: signupb4519wCVMpMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveY9e9SNIgFmMeta?.name ?? "streaming-event_id-live",
    path: liveY9e9SNIgFmMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveY9e9SNIgFmMeta || {},
    alias: liveY9e9SNIgFmMeta?.alias || [],
    redirect: liveY9e9SNIgFmMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsyaY5mUMgWRMeta?.name ?? "tips",
    path: tipsyaY5mUMgWRMeta?.path ?? "/tips",
    meta: tipsyaY5mUMgWRMeta || {},
    alias: tipsyaY5mUMgWRMeta?.alias || [],
    redirect: tipsyaY5mUMgWRMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93G26CB2T3fBMeta?.name ?? "waiver-uuid",
    path: _91uuid_93G26CB2T3fBMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93G26CB2T3fBMeta || {},
    alias: _91uuid_93G26CB2T3fBMeta?.alias || [],
    redirect: _91uuid_93G26CB2T3fBMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactqgpqNYq82aMeta?.name ?? "widgets-calendars-compact",
    path: compactqgpqNYq82aMeta?.path ?? "/widgets/calendars/compact",
    meta: compactqgpqNYq82aMeta || {},
    alias: compactqgpqNYq82aMeta?.alias || [],
    redirect: compactqgpqNYq82aMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullgQrkTJDZOSMeta?.name ?? "widgets-calendars-full",
    path: fullgQrkTJDZOSMeta?.path ?? "/widgets/calendars/full",
    meta: fullgQrkTJDZOSMeta || {},
    alias: fullgQrkTJDZOSMeta?.alias || [],
    redirect: fullgQrkTJDZOSMeta?.redirect,
    component: () => import("/tmp/build_bdce9e5f/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]